<template>
	<div>
		<van-field :required="formCreateInject.rule.validate.required" readonly
			:label="formCreateInject.prop.title.title" :value="textValue" placeholder="" @click="show"
			input-align="right">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>
		<van-popup v-model="showPicker" round position="bottom" :safe-area-inset-bottom="true" get-container="body">
			<van-picker :title="formCreateInject.prop.title.title" value-key="label" show-toolbar :columns="options"
				@cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<script>
	import postjob from '@_system/components/formcomponents/common/select/postjob/select.vue'
	export default {
		extends: postjob,
		props: {

		},
		data() {
			return {
				ready: false,
				showPicker: false,
				options: [],
				columns: [],
				textValue:null
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			show() {
				if (!this.disabled && !this.readonly) {
					this.showPicker = true
				}
			},
			onConfirm(value) {
				if (value) {
					let postvalue = value.value
					this.textValue = value.label
					this.change(postvalue)
				}
				this.showPicker = false
			}
		}
	}
</script>
